import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import { vocabularyCodes } from '@/vocabularies/constants';
import { datasetSettingsFields } from '../state/state';
import { updateDatasetSettings } from '../actions';
import { datasetManagePermissions } from '../../sharing/constants';

const listItems = (datasetActions) => datasetActions.urls.map((item) => ({
  description: item.description,
  key: `dataset_settings_custom_action_${item.name}`,
  text: item.name,
  value: item.name,
}));

const DatasetActionsDropdown = ({
  actions,
  category,
  code,
  datasetActions,
  disabled,
  updateDatasetLinks,
  name,
}) => {
  const intl = useIntl();
  const onDropdownChange = (value) => {
    const availableSelected = actions.urls.filter((item) => value.includes(item.name)).map((item) => item.name);
    updateDatasetLinks(category, code, { dataset_actions: availableSelected }, name);
  };

  return (
    <Dropdown
      fluid
      search
      selection
      multiple
      direction="left"
      className="aridhia-dataset-settings-custom-action max-content min-w-230"
      value={datasetActions}
      options={listItems(actions)}
      disabled={disabled}
      noResultsMessage={intl.formatMessage({ id: 'dataset.settings.custom.actions.field.no.more.links' })}
      onChange={(e, { value }) => onDropdownChange(value)}
      placeholder={intl.formatMessage({ id: 'dataset.settings.custom.actions.field.placeholder' })}
    />
  );
};

const mapStateToProps = ({
  datasetSettings: { settings },
  datasetUsers: { permissions },
  vocabularies: { vocabularies },
}, { category, code }) => {
  const perms = findResult(permissions, category, code) || { ...readStates };
  const item = findResult(settings, category, code) || { ...datasetSettingsFields(), ...saveStates };

  return ({
    actions: findResult(vocabularies, 'all', vocabularyCodes.DATASET_ACTIONS),
    datasetActions: item.dataset_actions,
    disabled: item.saveStatus === states.PENDING || !perms[datasetManagePermissions.SETTINGS],
  });
};

const mapDispatchToProps = {
  updateDatasetLinks: updateDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetActionsDropdown);
